import React, { Component } from 'react';
import Cert from './Cert';
import { v4 as uuidv4 } from 'uuid';

export default class CertifcationsContainer extends Component {
    static defaultProps = {
        certs: ["Bootstrap", "Responsive Web Design", "Javascript", "React"]
    }
    render() {
        const certs = this.props.certs.map((cert, idx) => {
            const id = uuidv4();
            const index = idx;
            return (
                <div className="col-12 col-md-4 m-auto">
                    <Cert id={id} name={cert} key={id} index={index} />
                </div>
            )
        })

        return (
            <div id="certs">
                <h1>Certifications</h1>
                <div className="row text-center">
                    {certs}
                </div>
            </div >
        )
    }
}
